export default __webpack_public_path__ + "./images/rs.0675aa89.png";